/**
 * AcceptanceApprovalViewer Parent Component
 * This component serves as the main container and can have child components inside "components/" folder.
 */
import React from "react";
import styles from "./AcceptanceApprovalViewer.module.css";
import { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import { AcceptanceApprovalViewerProps } from "./AcceptanceApprovalViewer.utils";
import { FieldProps } from "../../../../../Reusables/components/InputFieldsController/InputFieldsController.utils";
import CygnusForm from "../../../../../Reusables/components/CygnusForm/CygnusForm";

/**
 * Full-screen modal for previewing forms before submission.
 */
export const AcceptanceApprovalViewer: React.FC<
  AcceptanceApprovalViewerProps
> = ({ sharedData, setSharedData, onValidationChange, onFormLoaded }) => {
  // State variables
  const [clientFormFields, setClientFormFields] = useState<FieldProps[]>(
    sharedData.acceptanceFormData
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (sharedData.acceptanceFormData.length === 0) {
      setLoading(true);
    } else {
      setClientFormFields(sharedData.acceptanceFormData);
      
      // Check if there are any fields with API dropdowns
      const hasApiDropdowns = sharedData.acceptanceFormData.some(
        (field) => field.apiConfig?.apiKey
      );
      
      // If no API dropdowns, set loading to false immediately
      if (!hasApiDropdowns) {
        setLoading(false);
        // Notify parent immediately if no dropdowns to load
        onFormLoaded?.('acceptance');
      }
    }
  }, [sharedData.acceptanceFormData, onFormLoaded]);

  const handleDropdownsLoaded = () => {
    setLoading(false);
    // Notify parent that this form is fully loaded
    onFormLoaded?.('acceptance');
  };

  return (
    <>
      {loading && (
        <div className={styles.approvalLoader}>
          <div className="flex-row-center-center" style={{ marginLeft: 5 }}>
            <div style={{ width: "fit-content", padding: 0 }}>
              <ThreeCircles
                height="35"
                width="35"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_tertiary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_primary)"
              />
            </div>
            <h6 style={{ width: "fit-content", marginLeft: 10 }}>
              Loading your details
            </h6>
          </div>
        </div>
      )}
      
      <CygnusForm
        formId="cygnus-client-approval-acceptance-form"
        fields={clientFormFields}
        onFieldsChange={setClientFormFields}
        onValidationChange={() => {
          // NOT REQUIRED HERE
        }}
        onDropdownsLoaded={handleDropdownsLoaded}
        fieldVariant={sharedData.acceptanceFieldVariant}
        sectionVariant={sharedData.acceptanceSectionVariant}
        sectionLayout={sharedData.acceptanceSectionLayout}
      />
    </>
  );
};

export default AcceptanceApprovalViewer;